module.exports = __webpack_public_path__ + "static/fonts/TTNorms-Bold.aef39f5.eot";